import React, { useState, lazy, Suspense } from 'react';

// import Header from "../../components/Header";
// import OwlCarousel from 'react-owl-carousel';
// import 'owl.carousel/dist/assets/owl.carousel.css';
// import 'owl.carousel/dist/assets/owl.theme.default.css';
// import detailsSliderImg from "../../assest/images/detailsSlider-img.png";
// import ukpng from "../../assest/images/united-kingdom.png";
// import polandpng from "../../assest/images/poland.png";
// import francepng from "../../assest/images/france.png";
// import germanypng from "../../assest/images/germany.png";
// import userImgpng from "../../assest/images/userImg.png";
import ContentLoader from 'react-content-loader'
import helper, { generateCancellationPolicy, getLanguageName, getProductImageUrl } from '../../common/Helper';
// import Mapbox from '../../components/Mapbox';
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import BreadCrumb from '../../components/BreadCrumb';
import MapboxNew from '../../components/MapboxNew';
// import "react-owl-carousel2/lib/styles.css";
import Accordion from 'react-bootstrap/Accordion';
import Spinner from 'react-bootstrap/Spinner';
import moment from 'moment'
import NearbyAttractions from '../../components/NearbyAttractions';
import CustomAdvanceDropdown from '../../components/CustomAdvanceDropdown';
import ListLoading from '../../components/ListLoading';
// const OwlCarousel = lazy(() => import('react-owl-carousel'));

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import WatchLottieIcon from '../../components/WatchLottieIcon';
import MapboxRoute from '../../components/MapboxRoute';




const Index = ({
    isAdultDropBoxVisible,
    toggleDropBox,
    adultDropBoxRef,
    isDateDropBoxVisible,
    dateDropBoxRef,
    calendarRef,
    isTimeDropBoxVisible,
    timeDropBoxRef,
    toggleMap,
    isLoading,
    recordDetail,
    mapLoaded,
    breadcrumbList,
    isProductLiked,
    toggleLike,
    onClickShareIcon,
    expanded,
    setExpanded,
    descriptionRef,
    isOverflowing,
    isAdminLoggedin,
    companyDetail,
    supplierDetail,
    setIsDateDropBoxVisible,
    date,
    activeKey,
    closeAccordion,
    setActiveKey,
    isAvailabilityLoading,
    dateSchedule,
    slotNotAvailabel,
    toggleAccordion,
    productPricingCategories,
    onAddOrRemove,
    userCartData,
    onClickTime,
    ratesList,
    selectedTime,
    onClickRate,
    selectedRate,
    pricingRef,
    tieredPricingRef,
    onChangeGroupSize,
    isSimilarTourLoading,
    similarTours,
    flatpickrInstance,
    onClickContinue,
    cancellationPolicy,
    productList,
    onClickLoadMore,
    supplierProductNextPageUrl,
    isDefLoading,
    isSupplierProductLoading,
    toggleRealExpMap,
    realExpMapLoaded,
    today,
    togglePlace,
    handleSeePlacesLessClick,
    handleSeePlacesMoreClick,
    showAllPlaces,

    isPickupLoading,
    pickupNextPageUrl,
    pickupList,
    onClickLoadMorePickup,
    disableButtons,

    toggleRouteMap,
    routeMapLoaded,
    isDefLoadingPickup
}) => {



    // const options = {
    //     lazyLoad: true,
    //     loop: false,
    //     margin: 10,
    //     dots: false,
    //     nav: true,
    //     navText: ['<i class="fa-solid fa-chevron-left"></i>', '<i class="fa-solid fa-chevron-right"></i>'],
    //     responsive: {
    //         0: {
    //             items: 1
    //         },
    //         600: {
    //             items: 2
    //         },
    //         1000: {
    //             items: 3
    //         }
    //     }
    // };
    const [isOpen, setIsOpen] = useState(false);
    const [photoIndex, setPhotoIndex] = useState(0);
    // const galry = recordDetail?.images?.map(
    //     (img) => helper.S3Url + "/" + helper.productImageDir + "/" + img.image
    // );
    const galry = recordDetail?.images?.map(
        (img) => getProductImageUrl(img.image)
    );
    const newFirstElement = helper.S3Url + '/' + helper.productImageDir + '/' + recordDetail?.cover_image
    // const images = [newFirstElement].concat(galry) // [ 4, 3, 2, 1 ]
    const images = galry // [ 4, 3, 2, 1 ]

    // const pickupPlaces = recordDetail?.product_pickup_places || [];

    // const testPickupPlaces = [
    //     ...pickupPlaces,
    //     ...Array.from({ length: 50 - pickupPlaces.length }, (_, i) => ({
    //         title: `Fake Place ${i + 1}`,
    //     })),
    // ];
    // const visiblePlaces = showAllPlaces ? pickupPlaces : pickupPlaces.slice(0, 5);
    // const remainingPlacesCount = pickupPlaces.length - visiblePlaces.length;

    function goToBookRightBox() {
        const target = document.querySelector('.bookRightBox');
        if (target) {
            target.scrollIntoView({ behavior: 'smooth' });
        }
    }

    return (
        <>
            {/* <Header /> */}


            <section className="detailsMian" style={{ padding: "unset" }}>
                <div className="container-fluid-close">
                    <div className="detailsSlider">
                        {
                            isLoading ?
                                <ContentLoader
                                    backgroundColor="#e0e0d9"
                                    foregroundColor="#d6d6d0"
                                    viewBox={`0 0 ${window.innerWidth} 416`}
                                    width="100%"
                                    height="416"
                                >
                                    <rect x="0" y="0" rx="0" ry="0" width="100%" height="416" />
                                </ContentLoader> :

                                recordDetail?.images && recordDetail?.images.length > 0 &&

                                // <Suspense fallback={<div>Loading carousel...</div>}>
                                //     <OwlCarousel className='owl-theme' id="mobileSlider-2" {...options}>
                                //         {
                                //             recordDetail?.images.map((img, key) => {
                                //                 return (
                                //                     <div className="item" key={key}>
                                //                         <div className="sliderImg">
                                //                             <img
                                //                                 className="owl-lazy"
                                //                                 data-src={getProductImageUrl(img.image)}
                                //                                 alt={img?.alternate_text}
                                //                                 onClick={() => {
                                //                                     setPhotoIndex(key); // Set the current index of the image clicked
                                //                                     setIsOpen(true); // Open the lightbox
                                //                                 }}
                                //                             />
                                //                         </div>
                                //                     </div>
                                //                 )
                                //             })
                                //         }

                                //     </OwlCarousel>
                                // </Suspense>

                                <Swiper
                                    modules={[Navigation, Pagination]}
                                    // className='owl-theme'
                                    navigation
                                    // pagination={{ clickable: true }}
                                    // lazy={true}
                                    loop={false}
                                    spaceBetween={10}
                                    slidesPerView={1}
                                    // navigation={{
                                    //     nextEl: '.swiper-button-next',
                                    //     prevEl: '.swiper-button-prev',
                                    // }}
                                    breakpoints={{
                                        0: {
                                            slidesPerView: 1,
                                        },
                                        600: {
                                            slidesPerView: 2,
                                        },
                                        1000: {
                                            slidesPerView: 3,
                                        },
                                    }}

                                >
                                    {/* <OwlCarousel className='owl-theme' id="mobileSlider-2" {...options}> */}
                                    {
                                        recordDetail?.images.map((img, key) => {
                                            return (
                                                <SwiperSlide key={key} className='owl-theme'>
                                                    <div className="item">
                                                        <div className="sliderImg">
                                                            <img
                                                                src={getProductImageUrl(img.image)}
                                                                alt={img?.alternate_text}
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    setPhotoIndex(key); // Set the current index of the image clicked
                                                                    setIsOpen(true); // Open the lightbox
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </SwiperSlide>
                                            )
                                        })
                                    }

                                    {/* </OwlCarousel> */}
                                </Swiper>

                        }
                        {isOpen && (
                            <Lightbox
                                mainSrc={images[photoIndex]}
                                nextSrc={images[(photoIndex + 1) % images.length]}
                                prevSrc={images[(photoIndex + images.length - 1) % images.length]}
                                onCloseRequest={() => setIsOpen(false)} // Close lightbox
                                onMovePrevRequest={() =>
                                    setPhotoIndex((photoIndex + images.length - 1) % images.length)
                                } // Navigate to the previous image
                                onMoveNextRequest={() =>
                                    setPhotoIndex((photoIndex + 1) % images.length)
                                } // Navigate to the next image
                                animationDuration={300} // Smooth animation
                                // imageCaption={recordDetail?.images[photoIndex]?.alternate_text} // Optional: show alternate text as caption
                                reactModalStyle={{
                                    overlay: {
                                        backgroundColor: "rgba(0, 0, 0, 0)", // Transparent background
                                    },
                                }}
                                onImageLoadError={() => {
                                    console.warn("Lightbox failed to load:", images[photoIndex]);
                                    setIsOpen(false);
                                }}
                            />
                        )}
                    </div>
                </div>
            </section>

            <div className="detasilTitle">
                <div className="container">
                    <div className="detasilBox">
                        {/* <div className="searchBox">
                            <input className="main" type="search" placeholder="Находите места и занятия, которыми можно заняться" />
                            <i className="fa-solid fa-location-dot"></i>
                            <div className="innerSecrch">
                                <div className="srcBox">
                                    <input type="search" placeholder="Seacrh" />
                                    <i className="fa-solid fa-magnifying-glass"></i>
                                </div>
                            </div>
                        </div> */}
                        <div className="" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            {
                                isLoading ?

                                    <div className='mt-2'>
                                        <ContentLoader
                                            backgroundColor="#e0e0d9"
                                            foregroundColor="#d6d6d0"
                                            height="30" width="300" viewBox="12 10 300 30" >
                                            <rect x="15" y="15" rx="4" ry="5" width="300" height="30" />
                                        </ContentLoader>
                                    </div> :
                                    <>
                                        <BreadCrumb list={breadcrumbList} />
                                        <span className='listingld-label'>Listing ID : {recordDetail?.id}</span>
                                    </>
                            }

                        </div>
                        <div className="sectionTitle shareIcon">
                            {
                                isLoading ?

                                    <ContentLoader
                                        backgroundColor="#e0e0d9"
                                        foregroundColor="#d6d6d0"
                                        height="60" width="900" viewBox="12 10 900 60" >
                                        <rect x="15" y="15" rx="4" ry="4" width="900" height="54" />
                                    </ContentLoader> :
                                    <h3>{recordDetail?.title}</h3>}


                            <ul>
                                {
                                    isLoading ? <ContentLoader
                                        backgroundColor="#e0e0d9"
                                        foregroundColor="#d6d6d0"
                                        height="60" width="95" viewBox="0 10 95 60" >
                                        <rect x="15" y="15" rx="4" ry="4" width="95" height="60" />
                                    </ContentLoader> :
                                        <>
                                            <li><a href="javascript:void(0)" onClick={() => onClickShareIcon()}><i className="fa-solid fa-arrow-up-from-bracket"></i></a></li>

                                            <li>
                                                <a href="javascript:void(0)" onClick={() => toggleLike(!isProductLiked)}>
                                                    {
                                                        isProductLiked ?
                                                            <i className="fa-solid fa-heart redHeart"></i>
                                                            :
                                                            <i className="fa-regular fa-heart"></i>
                                                    }
                                                </a></li>
                                        </>
                                }

                            </ul>
                        </div>
                        {/* <div>
                            {isLoading ?

                                <ContentLoader
                                    backgroundColor="#e0e0d9"
                                    foregroundColor="#d6d6d0"
                                    height="30" width="300" viewBox="12 10 300 30" >
                                    <rect x="15" y="15" rx="4" ry="5" width="300" height="30" />
                                </ContentLoader> :

                                <span className='listingld-label'>Listing ID : {recordDetail?.id}</span>
                            }
                        </div> */}
                    </div>
                </div>
            </div>

            <section className="booking">
                <div className="booking-part">
                    <div className="container">
                        <div className="bookingBox">
                            <div className="row">
                                <div className="col-lg-7">
                                    <div className="bookLeftBox">
                                        <div className="mainContentBox">
                                            <div className="activityBox">
                                                {
                                                    isLoading ?

                                                        <ContentLoader
                                                            backgroundColor="#e0e0d9"
                                                            foregroundColor="#d6d6d0"
                                                            height="50" width="200" viewBox="12 10 200 50" >
                                                            <rect x="15" y="15" rx="4" ry="4" width="200" height="54" />
                                                        </ContentLoader> :
                                                        <h4 className="yellowText">Activity</h4>
                                                }
                                                {
                                                    isLoading ?
                                                        <p className="green">
                                                            <ContentLoader
                                                                backgroundColor="#e0e0d9"
                                                                foregroundColor="#d6d6d0"
                                                                height="150" width="300" viewBox="12 10 300 150" >
                                                                <rect x="0" y="0" rx="4" ry="4" width="300" height="150" />
                                                            </ContentLoader> </p> :
                                                        <>
                                                            {/* <p className="green">{recordDetail?.short_description}</p> */}
                                                            <div
                                                                id='full_description_text_activity'
                                                                className={`comon-tags-class full_description_text_activity ${expanded ? "expanded" : "collapsed"}`}
                                                                dangerouslySetInnerHTML={{ __html: recordDetail?.full_description }}
                                                                ref={descriptionRef}

                                                            />
                                                            {
                                                                isOverflowing &&
                                                                <div className="showmoreBtnContainer" style={{ marginTop: "15px", marginBottom: "15px", display: "flex", justifyContent: "end", alignItems: "center", gap: "10px" }}>
                                                                    {
                                                                        expanded &&
                                                                        <div className="bookNowBtn">
                                                                            <a href="javascript:void(0)" className='bookNowLink' onClick={() => goToBookRightBox()}>
                                                                                {"Book Now"}
                                                                            </a>
                                                                        </div>
                                                                    }
                                                                    <div className="showmoreBtn">
                                                                        <a href="javascript:void(0)" onClick={() => setExpanded(!expanded)}>
                                                                            {expanded ? "Show less" : "Show more"}
                                                                        </a>
                                                                    </div>

                                                                </div>
                                                            }
                                                        </>
                                                }


                                            </div>
                                            <>
                                                {
                                                    recordDetail?.product_detail?.is_show_itinerary_map == true &&
                                                    recordDetail?.product_detail?.route != null &&
                                                    <div className="meetingPoint mt-3 mb-3">
                                                        {
                                                            recordDetail?.product_detail.route &&
                                                            <div className="clickMap">
                                                                <button className="btn btnMap" id='btnRouteMap' type='button' onClick={toggleRouteMap}>Itinerary Map here</button>
                                                                <div className="routeMapBox" style={{
                                                                    opacity: 0,
                                                                    maxHeight: "0",
                                                                    overflow: "hidden",
                                                                    transition: "opacity 0.5s ease, max-height 0.5s ease",
                                                                }}>
                                                                    {
                                                                        // mapLoaded &&
                                                                        <MapboxRoute
                                                                            routeData={recordDetail?.product_detail?.route ? JSON.parse(recordDetail?.product_detail.route) : null}
                                                                            mapLoaded={routeMapLoaded}
                                                                        />
                                                                    }
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                }
                                            </>

                                            {
                                                isLoading ?

                                                    <div className="ticketDetails">

                                                        <ContentLoader
                                                            backgroundColor="#e0e0d9"
                                                            foregroundColor="#d6d6d0"
                                                            height="50" width="250" viewBox="12 10 250 50" >
                                                            <rect x="15" y="15" rx="4" ry="4" width="250" height="54" />
                                                        </ContentLoader>

                                                        <div className="ticketBox">
                                                            <div className="leftBox">

                                                                <ContentLoader
                                                                    backgroundColor="#e0e0d9"
                                                                    foregroundColor="#d6d6d0"
                                                                    height="50" width="250" viewBox="12 10 250 50" >
                                                                    <rect x="15" y="15" rx="4" ry="4" width="250" height="54" />
                                                                </ContentLoader>
                                                            </div>
                                                            <div className="rightBox">
                                                                <ContentLoader
                                                                    backgroundColor="#e0e0d9"
                                                                    foregroundColor="#d6d6d0"
                                                                    height="50" width="325" viewBox="12 10 325 50" >
                                                                    <rect x="15" y="15" rx="4" ry="4" width="325" height="54" />
                                                                </ContentLoader>
                                                            </div>
                                                        </div>
                                                        <div className="ticketBox">
                                                            <div className="leftBox">

                                                                <ContentLoader
                                                                    backgroundColor="#e0e0d9"
                                                                    foregroundColor="#d6d6d0"
                                                                    height="50" width="250" viewBox="12 10 250 50" >
                                                                    <rect x="15" y="15" rx="4" ry="4" width="250" height="54" />
                                                                </ContentLoader>
                                                            </div>
                                                            <div className="rightBox">
                                                                <ContentLoader
                                                                    backgroundColor="#e0e0d9"
                                                                    foregroundColor="#d6d6d0"
                                                                    height="50" width="325" viewBox="12 10 325 50" >
                                                                    <rect x="15" y="15" rx="4" ry="4" width="325" height="54" />
                                                                </ContentLoader>
                                                            </div>
                                                        </div>
                                                        <div className="ticketBox">
                                                            <div className="leftBox">

                                                                <ContentLoader
                                                                    backgroundColor="#e0e0d9"
                                                                    foregroundColor="#d6d6d0"
                                                                    height="50" width="250" viewBox="12 10 250 50" >
                                                                    <rect x="15" y="15" rx="4" ry="4" width="250" height="54" />
                                                                </ContentLoader>
                                                            </div>
                                                            <div className="rightBox">

                                                                <ContentLoader
                                                                    backgroundColor="#e0e0d9"
                                                                    foregroundColor="#d6d6d0"
                                                                    height="50" width="325" viewBox="12 10 325 50" >
                                                                    <rect x="15" y="15" rx="4" ry="4" width="325" height="54" />
                                                                </ContentLoader>
                                                            </div>
                                                        </div>
                                                        <div className="ticketBox">
                                                            <div className="leftBox">

                                                                <ContentLoader
                                                                    backgroundColor="#e0e0d9"
                                                                    foregroundColor="#d6d6d0"
                                                                    height="50" width="250" viewBox="12 10 250 50" >
                                                                    <rect x="15" y="15" rx="4" ry="4" width="250" height="54" />
                                                                </ContentLoader>
                                                            </div>
                                                            <div className="rightBox">
                                                                <ContentLoader
                                                                    backgroundColor="#e0e0d9"
                                                                    foregroundColor="#d6d6d0"
                                                                    height="50" width="325" viewBox="12 10 325 50" >
                                                                    <rect x="15" y="15" rx="4" ry="4" width="325" height="54" />
                                                                </ContentLoader>
                                                            </div>
                                                        </div>
                                                        <div className="ticketBox">
                                                            <div className="leftBox">

                                                                <ContentLoader
                                                                    backgroundColor="#e0e0d9"
                                                                    foregroundColor="#d6d6d0"
                                                                    height="50" width="250" viewBox="12 10 250 50" >
                                                                    <rect x="15" y="15" rx="4" ry="4" width="250" height="54" />
                                                                </ContentLoader>
                                                            </div>
                                                            <div className="rightBox">
                                                                <ContentLoader
                                                                    backgroundColor="#e0e0d9"
                                                                    foregroundColor="#d6d6d0"
                                                                    height="50" width="325" viewBox="12 10 325 50" >
                                                                    <rect x="15" y="15" rx="4" ry="4" width="325" height="54" />
                                                                </ContentLoader>
                                                            </div>
                                                        </div>
                                                    </div> :
                                                    <div className="ticketDetails">

                                                        <h4 className="yellowText">About this Activity</h4>

                                                        {
                                                            isAdminLoggedin &&

                                                            <div className="ticketBox">
                                                                <div className="leftBox" style={{ alignItems: "baseline" }}>
                                                                    <span><i className="bi bi-person-fill"></i></span>
                                                                    <h6>Administator Detail</h6>

                                                                </div>
                                                                <div className="rightBox admin-visible-detail notranslate" translate="no">
                                                                    <p className="green pt-2"><strong>Product Id</strong> : {recordDetail?.id}</p>
                                                                    <p className="green"><strong>{recordDetail?.tour_provider}</strong> : {recordDetail?.tour_provider_product_id}</p>
                                                                    <p className="green"><strong>Sold By</strong> : {companyDetail?.legal_company_name}</p>
                                                                    {
                                                                        (companyDetail?.owner_first_name || companyDetail?.owner_last_name) &&
                                                                        <p className="green"><strong>Name</strong> : {companyDetail?.owner_first_name} {companyDetail?.owner_last_name}</p>
                                                                    }
                                                                    <p className="green"><strong>Phone</strong> : {companyDetail?.contact_phone ? companyDetail?.contact_phone : '-'}</p>
                                                                    <p className="green"><strong>Email</strong> : {companyDetail?.contact_email ? companyDetail?.contact_email : '-'}</p>
                                                                    <p className="green"><strong>Commission</strong> : {recordDetail?.commission}%  (We receive total)</p>

                                                                </div>
                                                            </div>
                                                        }

                                                        <div className="ticketBox">
                                                            <div className="leftBox">
                                                                <span><i className="bi bi-calendar2-event-fill"></i></span>
                                                                <h6>When to book?</h6>

                                                            </div>
                                                            <div className="rightBox">

                                                                <p className="green">You can book up to the start time, as long as there are places remaining. Book now to guarantee your spot.</p>
                                                            </div>
                                                        </div>
                                                        <div className="ticketBox">
                                                            <div className="leftBox">
                                                                <span><i className="bi bi-person-wheelchair"></i></span>
                                                                <h6>Accessibility</h6>

                                                            </div>
                                                            <div className="rightBox">
                                                                {
                                                                    recordDetail?.is_wheelchair_accessible == true ?
                                                                        <p className="green">Physical: Wheelchair accessible. An accompanying person is required</p>
                                                                        :
                                                                        <p className="green">Physical: Wheelchair Not accessible</p>

                                                                }
                                                            </div>
                                                        </div>
                                                        <div className="ticketBox">
                                                            <div className="leftBox">
                                                                <span><i className="bi bi-clock-fill"></i></span>
                                                                <h6>Duration</h6>

                                                            </div>
                                                            <div className="rightBox">
                                                                <p className="green">{recordDetail?.duration}</p>

                                                            </div>
                                                        </div>
                                                        <div className="ticketBox">
                                                            <div className="leftBox" style={recordDetail?.product_host_working_language?.length > 0 ? { alignItems: "baseline" } : { alignItems: "center" }}>
                                                                <span><i className="bi bi-chat-square-text-fill"></i></span>
                                                                <h6>Language</h6>

                                                            </div>
                                                            <div className="rightBox">
                                                                {
                                                                    recordDetail?.product_host_working_language?.length > 0 ?
                                                                        recordDetail?.product_host_working_language?.map((lang) => {
                                                                            return (
                                                                                <p className="green" style={{ paddingBottom: "0px" }}>
                                                                                    {getLanguageName(lang?.name)} - Speaking Guide
                                                                                </p>
                                                                            )
                                                                        }) : " - "
                                                                }

                                                            </div>
                                                        </div>
                                                        <div className="ticketBox">
                                                            <div className="leftBox">
                                                                <span><i className="bi bi-file-earmark-text-fill"></i></span>
                                                                <h6>Type of voucher</h6>

                                                            </div>
                                                            <div className="rightBox">
                                                                <p className="green">Electronic. Show the voucher on your phone.</p>
                                                            </div>
                                                        </div>

                                                    </div>

                                            }
                                            {
                                                isLoading ?
                                                    <div className="cancelBox">
                                                        <ContentLoader
                                                            backgroundColor="#e0e0d9"
                                                            foregroundColor="#d6d6d0"
                                                            height="50" width="200" viewBox="12 10 200 50" >
                                                            <rect x="15" y="15" rx="4" ry="4" width="200" height="54" />
                                                        </ContentLoader>

                                                        <p className="green">
                                                            <ContentLoader
                                                                backgroundColor="#e0e0d9"
                                                                foregroundColor="#d6d6d0"
                                                                height="25" width="300" viewBox="12 10 300 25" >
                                                                <rect x="15" y="15" rx="4" ry="4" width="300" height="54" />
                                                            </ContentLoader>
                                                        </p>
                                                    </div> :
                                                    <div className="cancelBox">
                                                        <h4 className="yellowText">Cancellations</h4>
                                                        <p className="green">
                                                            {/* {recordDetail?.cancellation_policy} */}
                                                            {
                                                                cancellationPolicy ? cancellationPolicy : "Please select date and time"
                                                            }

                                                        </p>
                                                    </div>
                                            }
                                            {
                                                isLoading ?
                                                    <div className="cancelBox">
                                                        <ContentLoader
                                                            backgroundColor="#e0e0d9"
                                                            foregroundColor="#d6d6d0"
                                                            height="50" width="200" viewBox="12 10 200 50" >
                                                            <rect x="15" y="15" rx="4" ry="4" width="200" height="54" />
                                                        </ContentLoader>

                                                        <p className="green">
                                                            <ContentLoader
                                                                backgroundColor="#e0e0d9"
                                                                foregroundColor="#d6d6d0"
                                                                height="25" width="300" viewBox="12 10 300 25" >
                                                                <rect x="15" y="15" rx="4" ry="4" width="300" height="54" />
                                                            </ContentLoader>
                                                        </p>
                                                    </div> :

                                                    pickupList && pickupList.length > 0 ?
                                                        <div className='pickupPlaces'>
                                                            <h4 className="yellowText">Pick-up Places</h4>
                                                            {/* <div className="clickMap">
                                                                <button className="btn btnMap" id='btnPlace' onClick={togglePlace} type='button'>Show Places</button>
                                                            </div> */}
                                                            <div className="pickup_box" style={{
                                                                // opacity: 0,
                                                                maxHeight: "500px",
                                                                overflowY: "auto",
                                                                transition: "opacity 0.5s ease, max-height 0.5s ease",
                                                            }}>
                                                                <ul>
                                                                    {

                                                                        pickupList.map((pl, ipl) => {
                                                                            return (
                                                                                // <li key={ipl}><p>{pl?.title} : <span>{pl?.address ? pl?.address + ',' : ''} {pl?.postCode} {pl?.city}</span></p></li>
                                                                                <li key={ipl}>
                                                                                    <p>
                                                                                        {pl?.title} :
                                                                                        <span>
                                                                                            {pl?.address
                                                                                                ? `${pl.address.trim().replace(/,+$/, '')}, `
                                                                                                : ''}
                                                                                            {pl?.postCode} {pl?.city}
                                                                                        </span>
                                                                                    </p>
                                                                                </li>
                                                                            )
                                                                        })
                                                                    }

                                                                </ul>
                                                                {
                                                                    isPickupLoading ?
                                                                        <ListLoading /> :
                                                                        pickupList?.length > 0 && pickupNextPageUrl &&



                                                                        <div className="seeMore">
                                                                            <a href="javascript:void(0)" onClick={() => onClickLoadMorePickup(pickupNextPageUrl.split('=')[1])}>
                                                                                Load more
                                                                            </a>
                                                                        </div>
                                                                }
                                                            </div>
                                                        </div> : <></>
                                            }
                                            {
                                                isLoading ?

                                                    <div className="meetingPoint">
                                                        <ContentLoader
                                                            backgroundColor="#e0e0d9"
                                                            foregroundColor="#d6d6d0"
                                                            height="50" width="200" viewBox="12 10 200 50" >
                                                            <rect x="15" y="15" rx="4" ry="4" width="200" height="54" />
                                                        </ContentLoader>
                                                        <div className="addressBox">
                                                            <ContentLoader
                                                                backgroundColor="#e0e0d9"
                                                                foregroundColor="#d6d6d0"
                                                                height="100" width="300" viewBox="12 10 300 100" >
                                                                <rect x="15" y="15" rx="4" ry="4" width="300" height="100" />
                                                            </ContentLoader>

                                                        </div>
                                                        {/* <div className="clickMap">
                                                            <button className="btn btnMap" type='button' onClick={toggleMap}>Show Me In The Map</button>
                                                            <div className="mapBox" style={{
                                                                opacity: 0,
                                                                maxHeight: "0",
                                                                overflow: "hidden",
                                                                transition: "opacity 0.5s ease, max-height 0.5s ease",
                                                            }}>
                                                                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d235013.74843718624!2d72.41493399983852!3d23.020474096845316!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e848aba5bd449%3A0x4fcedd11614f6516!2sAhmedabad%2C%20Gujarat!5e0!3m2!1sen!2sin!4v1730894045698!5m2!1sen!2sin" style={{ border: 0 }} allowFullScreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                                                            </div>
                                                        </div> */}
                                                    </div> :
                                                    <>
                                                        {
                                                            recordDetail?.latitude &&

                                                            <div className="meetingPoint mt-3">
                                                                <h4 className="yellowText">Meeting point</h4>

                                                                <div className="addressBox">

                                                                    <div className="iconLand"><i className="fa-solid fa-location-dot"></i></div>
                                                                    <p className="green">Complete Operator information, including local telephone numbers at your destination, are included on your Confirmation Voucher. Our Product Managers select only the most experienced and reliable operators in each destination, removing the guesswork for you, and ensuring your peace of mind.</p>
                                                                </div>
                                                                {
                                                                    recordDetail?.latitude &&
                                                                    <div className="clickMap">
                                                                        <button className="btn btnMap" id='btnMap' type='button' onClick={toggleMap}>Show Me In The Map</button>
                                                                        <div className="mapBox" style={{
                                                                            opacity: 0,
                                                                            maxHeight: "0",
                                                                            overflow: "hidden",
                                                                            transition: "opacity 0.5s ease, max-height 0.5s ease",
                                                                        }}>
                                                                            {
                                                                                // mapLoaded &&
                                                                                <MapboxNew
                                                                                    lat={Number(recordDetail?.latitude)}
                                                                                    lng={Number(recordDetail?.longitude)}
                                                                                    zoom={recordDetail?.mapZoomLevel}
                                                                                    mapLoaded={mapLoaded}
                                                                                />
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </div>
                                                        }

                                                        {/*  */}
                                                        {
                                                            recordDetail?.real_experiance_latitude &&
                                                            <div className="meetingPoint mt-3">
                                                                <h4 className="yellowText">Real Experiance Location</h4>

                                                                <div className="addressBox">

                                                                    <div className="iconLand"><i className="fa-solid fa-location-dot"></i></div>
                                                                    <p className="green">Complete Operator information, including local telephone numbers at your destination, are included on your Confirmation Voucher. Our Product Managers select only the most experienced and reliable operators in each destination, removing the guesswork for you, and ensuring your peace of mind.</p>
                                                                </div>
                                                                {
                                                                    recordDetail?.real_experiance_latitude &&
                                                                    <div className="clickMap">
                                                                        <button className="btn btnMap" id='btnRealExpMap' type='button' onClick={toggleRealExpMap}>Show Me In The Map</button>
                                                                        <div className="realExpMapBox" style={{
                                                                            opacity: 0,
                                                                            maxHeight: "0",
                                                                            overflow: "hidden",
                                                                            transition: "opacity 0.5s ease, max-height 0.5s ease",
                                                                        }}>
                                                                            {
                                                                                // mapLoaded &&
                                                                                <MapboxNew
                                                                                    lat={Number(recordDetail?.real_experiance_latitude)}
                                                                                    lng={Number(recordDetail?.real_experiance_longitude)}
                                                                                    zoom={recordDetail?.mapZoomLevel}
                                                                                    mapLoaded={realExpMapLoaded}
                                                                                />
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </div>
                                                        }


                                                    </>
                                            }
                                        </div>
                                        {
                                            recordDetail?.product_detail?.trustindex_reviews != null &&
                                            recordDetail?.product_detail?.trustindex_reviews != '' &&
                                            <div className="mainReviewBox">
                                                <div className="topReviewBox">
                                                    <div className="leftBox">

                                                        <h5 className="yellowText mb-2">Our customers' reviews</h5>
                                                        <p>These are genuine reviews written by our customers.</p>
                                                    </div>
                                                </div>
                                                <div className="commentSec">
                                                    <div
                                                        className="full_description_text"
                                                        dangerouslySetInnerHTML={{ __html: recordDetail?.product_detail?.trustindex_reviews }}
                                                    />
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div className="col-lg-5">


                                    {
                                        // isAvailabilityLoading ?
                                        isLoading ?

                                            <div className="bookRightBox">
                                                <div className="selectDate">
                                                    <div className="selectDetails">
                                                        <h4 className="yellowText">   <ContentLoader
                                                            backgroundColor="#e0e0d9"
                                                            foregroundColor="#d6d6d0"
                                                            height="100" width="300" viewBox="12 10 300 100" >
                                                            <rect x="20" y="14" rx="3" ry="3" width="250" height="20" />
                                                            <rect x="20" y="50" rx="3" ry="3" width="70" height="20" />

                                                        </ContentLoader></h4>

                                                        <div className="multyDrop">

                                                            <div className="firstBox">
                                                                <ContentLoader
                                                                    speed={2}
                                                                    width={300}
                                                                    height={160}
                                                                    viewBox="0 0 300 160"
                                                                    backgroundColor="#e0e0d9"
                                                                    foregroundColor="#d6d6d0"
                                                                >
                                                                    <rect x="10" y="6" rx="4" ry="4" width="343" height="38" />
                                                                    <rect x="10" y="55" rx="4" ry="4" width="343" height="38" />
                                                                    <rect x="10" y="104" rx="4" ry="4" width="343" height="38" />
                                                                </ContentLoader>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div> :
                                            <div className="bookRightBox">
                                                <div className="selectDate">
                                                    <div className="text-center">
                                                        <h5 className='redText'>Real Time Availability

                                                            <WatchLottieIcon />
                                                        </h5>
                                                    </div>
                                                    <div className="selectDetails">
                                                        <h4 className="yellowText">Select participants and date</h4>
                                                        <Accordion activeKey={activeKey} alwaysOpen flush>
                                                            <Accordion.Item eventKey="0">
                                                                <Accordion.Header onClick={() => toggleAccordion("0")}> <span><i className="fa-solid fa-user"></i> People</span></Accordion.Header>
                                                                <Accordion.Body>
                                                                    <div className="adultDropBox" >
                                                                        <ul >
                                                                            {
                                                                                productPricingCategories?.length > 0 &&
                                                                                productPricingCategories.map((cat, i) => {
                                                                                    // console.log(cat.pricingCategoryId);

                                                                                    let ind = userCartData?.findIndex((e) => e?.catId == cat?.pricingCategoryId)
                                                                                    let cnt = ind != -1 ? userCartData[ind]?.qty : 0
                                                                                    let groupSize = ind != -1 ? userCartData[ind]?.groupSize : 0


                                                                                    return (
                                                                                        <li>
                                                                                            <div className="adultage" key={i}>
                                                                                                <h6 className="mb-1">{cat.title}</h6>
                                                                                                {
                                                                                                    cat.ticketCategory != "GROUP" && cat.maxAge > 0 &&
                                                                                                    <span>Age {cat.minAge} - {cat.maxAge}</span>
                                                                                                }
                                                                                            </div>
                                                                                            <div className='personDrop'>
                                                                                                {/* <div className="countBtn">
                                                                                                    <i className="fa-solid fa-circle-minus" onClick={() => onAddOrRemove(cat.pricingCategoryId, cat.ticketCategory, 'remove', cat.title)}></i>
                                                                                                    <span>{cnt}</span>
                                                                                                    <i className="fa-solid fa-circle-plus" onClick={() => onAddOrRemove(cat.pricingCategoryId, cat.ticketCategory, 'add', cat.title)}></i>
                                                                                                </div> */}
                                                                                                <div className="countBtn">
                                                                                                    <i
                                                                                                        className={`fa-solid fa-circle-minus ${disableButtons ? 'disabled' : ''}`}
                                                                                                        onClick={() => !disableButtons && onAddOrRemove(cat.pricingCategoryId, cat.ticketCategory, 'remove', cat.title)}
                                                                                                    ></i>
                                                                                                    <span>{cnt}</span>
                                                                                                    <i
                                                                                                        className={`fa-solid fa-circle-plus ${disableButtons ? 'disabled' : ''}`}
                                                                                                        onClick={() => !disableButtons && onAddOrRemove(cat.pricingCategoryId, cat.ticketCategory, 'add', cat.title)}
                                                                                                    ></i>
                                                                                                </div>
                                                                                                {
                                                                                                    cat.ticketCategory == "GROUP" && cnt > 0 &&

                                                                                                    // <select onChange={(e) => onChangeGroupSize(ind, e.target.value)}>
                                                                                                    //     <option value={1}>1</option>
                                                                                                    //     <option value={2}>2</option>
                                                                                                    //     <option value={3}>3</option>
                                                                                                    //     <option value={4}>4</option>
                                                                                                    //     <option value={5}>5</option>
                                                                                                    //     <option value={6}>6</option>
                                                                                                    // </select>

                                                                                                    <CustomAdvanceDropdown
                                                                                                        label={'Group Size'}
                                                                                                        options={[1, 2, 3, 4, 5, 6]}
                                                                                                        selectedState={groupSize}
                                                                                                        setSelectedState={(e) => onChangeGroupSize(ind, e)}
                                                                                                    // disabled={state.id}
                                                                                                    />
                                                                                                }
                                                                                            </div>
                                                                                        </li>
                                                                                    )
                                                                                })
                                                                            }
                                                                            {/* <li>
                                                                                <div className="adultage">
                                                                                    <h6 className="mb-1">Adults</h6>
                                                                                    <span>Ages 13 or above</span>
                                                                                </div>
                                                                                <div className="countBtn">
                                                                                    <i className="fa-solid fa-circle-minus"></i>
                                                                                    <span>0</span>
                                                                                    <i className="fa-solid fa-circle-plus"></i>
                                                                                </div>
                                                                            </li>
                                                                            <li>
                                                                                <div className="adultage">
                                                                                    <h6 className="mb-1">Children</h6>
                                                                                    <span>Ages 2 - 12</span>
                                                                                </div>
                                                                                <div className="countBtn">
                                                                                    <i className="fa-solid fa-circle-minus"></i>
                                                                                    <span>0</span>
                                                                                    <i className="fa-solid fa-circle-plus"></i>
                                                                                </div>
                                                                            </li>
                                                                            <li>
                                                                                <div className="adultage">
                                                                                    <h6 className="mb-1">Adults</h6>
                                                                                    <span>Under 2</span>
                                                                                </div>
                                                                                <div className="countBtn">
                                                                                    <i className="fa-solid fa-circle-minus"></i>
                                                                                    <span>0</span>
                                                                                    <i className="fa-solid fa-circle-plus"></i>
                                                                                </div>
                                                                            </li> */}
                                                                        </ul>
                                                                    </div>
                                                                </Accordion.Body>
                                                            </Accordion.Item>
                                                            <Accordion.Item eventKey="1">
                                                                {
                                                                    // date &&
                                                                    <Accordion.Header onClick={() => toggleAccordion("1")}>
                                                                        <span><i className="fa-solid fa-calendar-days"></i>{date ? date : "Select Date"}  </span>
                                                                    </Accordion.Header>
                                                                }
                                                                <Accordion.Body className='ourClickBox'>
                                                                    <div className="position-relative w-100 mt-3">
                                                                        {
                                                                            flatpickrInstance == null &&
                                                                            <div
                                                                                className='timeDropBox notfoundLabel'
                                                                                style={{
                                                                                    display: "inline-block",
                                                                                    padding: "10px",
                                                                                    backgroundColor: "rgb(253, 247, 232)",
                                                                                    color: "rgb(236, 187, 51)",
                                                                                    border: "1px solid rgb(236, 187, 51)",
                                                                                    borderRadius: "5px",
                                                                                    fontWeight: "bold",
                                                                                    width: "100%",
                                                                                    textAlign: "center",
                                                                                    // marginTop: "10px"
                                                                                }}
                                                                            >Please select People</div>}

                                                                        <div className="notranslate">
                                                                            <div className='notranslate' translate="no" ref={calendarRef} >
                                                                            </div>
                                                                        </div>



                                                                        {
                                                                            isAvailabilityLoading &&
                                                                            <div
                                                                                className="position-absolute top-50 start-50 translate-middle d-flex align-items-center justify-content-center bg-white bg-opacity-25"
                                                                                style={{ width: "100%", height: "100%", opacity: "75%" }}
                                                                            >
                                                                                <Spinner animation="border" variant="warning" />
                                                                            </div>
                                                                        }
                                                                    </div>

                                                                </Accordion.Body>
                                                            </Accordion.Item>
                                                            <Accordion.Item eventKey="2">
                                                                <Accordion.Header onClick={() => toggleAccordion("2")}> <span><i className="bi bi-clock-fill"></i> {selectedTime ? selectedTime.startTime : "Time"}</span></Accordion.Header>
                                                                <Accordion.Body>
                                                                    <div className="timeDropBox timeBox_second" ref={timeDropBoxRef}>
                                                                        {
                                                                            dateSchedule.length > 0 ?

                                                                                <ul>
                                                                                    {
                                                                                        dateSchedule.length > 0 &&
                                                                                        dateSchedule.map((tme, i) => {
                                                                                            return (

                                                                                                tme?.soldOut ?
                                                                                                    <li>
                                                                                                        <a
                                                                                                            translate="no"
                                                                                                            href="javascript:void(0)"
                                                                                                            className={'soldout-time notranslate'}
                                                                                                        >
                                                                                                            <del>{tme?.startTime}</del>

                                                                                                        </a>
                                                                                                    </li>
                                                                                                    :


                                                                                                    <li>
                                                                                                        <a
                                                                                                            href="javascript:void(0)"
                                                                                                            translate="no"
                                                                                                            className={selectedTime?.startTimeId == tme?.startTimeId ? 'time-selected notranslate' : 'notranslate'}
                                                                                                            onClick={() => onClickTime(tme?.startTimeId)}>
                                                                                                            {tme?.startTime}</a>
                                                                                                    </li>
                                                                                            )
                                                                                        })

                                                                                    }
                                                                                </ul> :
                                                                                slotNotAvailabel ?
                                                                                    <div
                                                                                        className='notfoundLabel'
                                                                                        style={{
                                                                                            display: "inline-block",
                                                                                            padding: "10px",
                                                                                            backgroundColor: "rgb(253, 247, 232)",
                                                                                            color: "rgb(236, 187, 51)",
                                                                                            border: "1px solid rgb(236, 187, 51)",
                                                                                            borderRadius: "5px",
                                                                                            fontWeight: "bold",
                                                                                            width: "100%",
                                                                                            textAlign: "center",
                                                                                            // marginTop: "10px"
                                                                                        }}>Slot Not Available For {slotNotAvailabel}</div> :
                                                                                    <div
                                                                                        className='notfoundLabel'
                                                                                        style={{
                                                                                            display: "inline-block",
                                                                                            padding: "10px",
                                                                                            backgroundColor: "rgb(253, 247, 232)",
                                                                                            color: "rgb(236, 187, 51)",
                                                                                            border: "1px solid rgb(236, 187, 51)",
                                                                                            borderRadius: "5px",
                                                                                            fontWeight: "bold",
                                                                                            width: "100%",
                                                                                            textAlign: "center"
                                                                                        }}
                                                                                    >Please select date</div>
                                                                        }
                                                                    </div>
                                                                </Accordion.Body>
                                                            </Accordion.Item>
                                                            <Accordion.Item eventKey="3">
                                                                <Accordion.Header onClick={() => toggleAccordion("3")}> <span><i className="bi bi-currency-exchange"></i>{selectedRate ? selectedRate.title : 'Rate'} </span></Accordion.Header>
                                                                <Accordion.Body>
                                                                    {
                                                                        ratesList?.length > 0 ?
                                                                            <>
                                                                                <h4 className="yellowText p-2">Choose Rate</h4>
                                                                                <div className="row " style={{ display: "block" }}>

                                                                                    {
                                                                                        ratesList.map((rte) => {
                                                                                            return (
                                                                                                <div className="col mb-4 mt-4" onClick={() => onClickRate(rte)}>
                                                                                                    <div className={`card rate-card ${selectedRate?.id == rte?.id ? 'selected' : ''}`}>
                                                                                                        <div className='d-flex align-items-start'>
                                                                                                            <div className="rate-header">{rte.title}</div>
                                                                                                            {
                                                                                                                selectedRate?.id == rte.id &&
                                                                                                                <span className="badge-selected"><i className="fas fa-check"></i> Selected</span>
                                                                                                            }
                                                                                                        </div>
                                                                                                        <div className="divider"></div>

                                                                                                        {
                                                                                                            rte.maxPerBooking != null && rte.maxPerBooking != 0 &&
                                                                                                            <div className="policy"><i className="fas fa-check-circle"></i> Can be booked upto {rte.maxPerBooking} per booking</div>
                                                                                                        }
                                                                                                        {/* <div className="policy" style={{ width: "85%" }}><i className="fas fa-check-circle"></i> {rte.cancellationPolicy.title}</div> */}
                                                                                                        <div className="policy" style={{ width: "85%" }}><i className="fas fa-check-circle"></i> {generateCancellationPolicy(JSON.stringify(rte.cancellationPolicy), date, selectedTime?.startTime, recordDetail?.product_detail?.time_zone)}</div>

                                                                                                        <p className="price notranslate" translate="no" >€{Number(rte?.totalPrice).toFixed(2)}</p>
                                                                                                    </div>
                                                                                                </div>
                                                                                            )
                                                                                        })
                                                                                    }
                                                                                </div>
                                                                            </>
                                                                            :

                                                                            <div
                                                                                className='timeDropBox timeBox_second notfoundLabel'
                                                                                style={{
                                                                                    display: "inline-block",
                                                                                    padding: "10px",
                                                                                    backgroundColor: "rgb(253, 247, 232)",
                                                                                    color: "rgb(236, 187, 51)",
                                                                                    border: "1px solid rgb(236, 187, 51)",
                                                                                    borderRadius: "5px",
                                                                                    fontWeight: "bold",
                                                                                    width: "100%",
                                                                                    textAlign: "center"
                                                                                }}
                                                                            >{!selectedTime ? "Please select Time" : 'Rates and pricing are not available for the selected date.'}</div>
                                                                    }
                                                                    {/* 
                                                                        <div class="col mb-4">
                                                                            <div class="card rate-card" onclick="selectRate(this)">
                                                                                <span class="badge-selected"><i class="fas fa-check"></i> Selected</span>
                                                                                <div class="rate-header">Non-Refundable</div>
                                                                                <div class="divider"></div>
                                                                                <div class="policy"><i class="fas fa-times-circle text-danger"></i> No cancellations allowed</div>
                                                                                <div class="policy"><i class="fas fa-times-circle text-danger"></i> No refunds</div>
                                                                                <p class="price">$80</p>
                                                                            </div>
                                                                        </div>

                                                                        <div class="col mb-4">
                                                                            <div class="card rate-card" onclick="selectRate(this)">
                                                                                <span class="badge-selected"><i class="fas fa-check"></i> Selected</span>
                                                                                <div class="rate-header">Flexible Rate</div>
                                                                                <div class="divider"></div>
                                                                                <div class="policy"><i class="fas fa-check-circle"></i> Cancel anytime</div>
                                                                                <div class="policy"><i class="fas fa-check-circle"></i> Full refund available</div>
                                                                                <p class="price">$120</p>
                                                                            </div>
                                                                        </div> */}

                                                                </Accordion.Body>
                                                            </Accordion.Item>

                                                        </Accordion>
                                                        {
                                                            selectedRate != null &&
                                                            <>
                                                                <h4 className="yellowText p-2">Booking Summary</h4>
                                                                <div className="ticket">
                                                                    <div className="ticket-header" style={{ backgroundImage: `url(${newFirstElement})` }}>
                                                                        {/* <span>Eiffel Tower Tour</span> */}
                                                                    </div>

                                                                    <div className="ticket-body">
                                                                        <div className="ticket-time notranslate" translate="no">{selectedTime ? selectedTime.startTime : ''}</div>
                                                                        <div className="ticket-date notranslate" translate="no">{moment(date).format('ddd DD MMMM yy')}</div>

                                                                        <div className="ticket-divider"></div>
                                                                        {
                                                                            userCartData.map((uc, i) => {

                                                                                const tier = selectedRate.tiers.find(t =>
                                                                                    t?.pricingCategoryId === uc.catId &&
                                                                                    t?.activityRateId === selectedRate.id &&
                                                                                    t?.maxPassengersRequired != null
                                                                                );

                                                                                let tieredPricingAry = tieredPricingRef?.current && JSON.parse(tieredPricingRef?.current).length ? JSON.parse(tieredPricingRef?.current) : [];
                                                                                let pricingAry = pricingRef?.current && JSON.parse(pricingRef?.current).length ? JSON.parse(pricingRef?.current) : [];
                                                                                // var catAmt = pricingAry.filter((p) => p.rateId == selectedRate.id && p.pricingCategoryId == uc.catId).length > 0 ? pricingAry.filter((p) => p.rateId == selectedRate.id && p.pricingCategoryId == uc.catId)[0].amount : 0
                                                                                // if (tier) {
                                                                                //     catAmt = tieredPricingAry.filter((p) => p.rateId == selectedRate.id && p.pricingCategoryId == uc.catId).length > 0 ? tieredPricingAry.filter((p) => p.rateId == selectedRate.id && p.pricingCategoryId == uc.catId)[0].amount : 0
                                                                                // }
                                                                                var catAmt = 0
                                                                                var match = pricingAry.find(
                                                                                    (p) =>
                                                                                        p.rateId == selectedRate.id &&
                                                                                        p.pricingCategoryId == uc.catId &&
                                                                                        date >= p.from &&
                                                                                        date <= (p.to ? p.to : today) &&
                                                                                        // (uc.qty >= Number(selectedRate.minPerBooking) && uc.qty >= Number(selectedRate.maxPerBooking))
                                                                                        (selectedRate.maxPerBooking != null ?
                                                                                            uc.qty >= Number(selectedRate.minPerBooking) && uc.qty <= Number(selectedRate.maxPerBooking) : true
                                                                                        )

                                                                                );
                                                                                catAmt = match ? match.amount : 0;
                                                                                if (tier) {
                                                                                    // var match = tieredPricingAry.find(
                                                                                    //     (p) =>
                                                                                    //         p.rateId == selectedRate.id &&
                                                                                    //         p.pricingCategoryId == uc.catId &&
                                                                                    //         date >= p.from &&
                                                                                    //         date <= (p.to ? p.to : today) &&
                                                                                    //         // (p.minQty <= Number(uc.qty) && p.maxQty >= Number(uc.qty))
                                                                                    //         ( 
                                                                                    //            p.maxQty != null ?
                                                                                    //             uc.qty >= Number(p.minQty) && uc.qty >= Number(p.maxQty) : true)
                                                                                    // );
                                                                                    let match = tieredPricingAry.find((p) => {
                                                                                        const minKey = 'minQty' in p ? 'minQty' : 'minPassengersRequired';
                                                                                        const maxKey = 'maxQty' in p ? 'maxQty' : 'maxPassengersRequired';

                                                                                        return (
                                                                                            p.rateId == selectedRate.id &&
                                                                                            p.pricingCategoryId == uc.catId &&
                                                                                            date >= p.from &&
                                                                                            date <= (p.to ? p.to : today) &&
                                                                                            uc.qty >= Number(p[minKey]) &&
                                                                                            uc.qty <= Number(p[maxKey])
                                                                                        );
                                                                                    });
                                                                                    catAmt = match ? match.amount : 0;
                                                                                }

                                                                                // console.log('selectedRate', selectedRate);
                                                                                // console.log('tier', tier);
                                                                                // console.log('catAmt', catAmt);

                                                                                return (
                                                                                    <div className="ticket-info" key={i}>
                                                                                        <span> {uc?.title}</span>
                                                                                        {
                                                                                            selectedRate.pricedPerPerson ?
                                                                                                <strong className='notranslate' translate="no">{uc.qty} x €{catAmt}</strong>
                                                                                                :
                                                                                                <strong className='notranslate' translate="no">{uc.qty}</strong>
                                                                                        }
                                                                                    </div>
                                                                                )
                                                                            })
                                                                        }

                                                                        <div className="ticket-divider"></div>

                                                                        <div className="total-amount">
                                                                            Total: <span className='notranslate' translate="no">€{Number(selectedRate?.totalPrice).toFixed(2)}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        }
                                                        <div className="continueBox">
                                                            <button className="btn continueBtn" onClick={() => onClickContinue()}>Continue <i className="fa-solid fa-chevron-right"></i></button>
                                                        </div>

                                                        {/* <div className="multyDrop">
                                                            <div className="secondBox">
                                                                <a className={isDateDropBoxVisible ? "active-border secondBoxClick commonClick" : "secondBoxClick commonClick"} href="javascript:void(0)" onClick={() => toggleDropBox('date')}>
                                                                    <div className="iconText">
                                                                        <h6><i className="fa-solid fa-calendar-days"></i> Select date</h6>
                                                                    </div>
                                                                    <div className="iconRight">
                                                                        <i className="fa-solid fa-chevron-down"></i>
                                                                    </div>
                                                                </a>
                                                                <div className="dateDropBox ourClickBox" ref={dateDropBoxRef}>
                                                                    <div ref={calendarRef}>
                                                                    </div>

                                                                </div>
                                                            </div>

                                                            <div className="firstBox mb-4">
                                                                <a className={isAdultDropBoxVisible ? "active-border firstBoxClick commonClick" : "firstBoxClick commonClick"} href="javascript:void(0)" onClick={() => toggleDropBox('age')}>
                                                                    <div className="iconText">
                                                                        <h6><i className="fa-solid fa-user"></i> Adult x 1</h6>
                                                                    </div>
                                                                    <div className="iconRight">
                                                                        <i className="fa-solid fa-chevron-down"></i>
                                                                    </div>
                                                                </a>
                                                                <div className="adultDropBox" ref={adultDropBoxRef}>
                                                                    <ul >
                                                                        <li>
                                                                            <div className="adultage">
                                                                                <h6 className="mb-1">Adults</h6>
                                                                                <span>Ages 13 or above</span>
                                                                            </div>
                                                                            <div className="countBtn">
                                                                                <i className="fa-solid fa-circle-minus"></i>
                                                                                <span>0</span>
                                                                                <i className="fa-solid fa-circle-plus"></i>
                                                                            </div>
                                                                        </li>
                                                                        <li>
                                                                            <div className="adultage">
                                                                                <h6 className="mb-1">Children</h6>
                                                                                <span>Ages 2 - 12</span>
                                                                            </div>
                                                                            <div className="countBtn">
                                                                                <i className="fa-solid fa-circle-minus"></i>
                                                                                <span>0</span>
                                                                                <i className="fa-solid fa-circle-plus"></i>
                                                                            </div>
                                                                        </li>
                                                                        <li>
                                                                            <div className="adultage">
                                                                                <h6 className="mb-1">Adults</h6>
                                                                                <span>Under 2</span>
                                                                            </div>
                                                                            <div className="countBtn">
                                                                                <i className="fa-solid fa-circle-minus"></i>
                                                                                <span>0</span>
                                                                                <i className="fa-solid fa-circle-plus"></i>
                                                                            </div>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>


                                                            <div className="thirdBox">
                                                                <a className={isTimeDropBoxVisible ? "active-border thirdBoxClick commonClick" : "thirdBoxClick commonClick"} href="javascript:void(0)" onClick={() => toggleDropBox('time')}>
                                                                    <div className="iconText">
                                                                        <h6><i className="bi bi-clock-fill"></i> Time</h6>
                                                                    </div>
                                                                    <div className="iconRight">
                                                                        <i className="fa-solid fa-chevron-down"></i>
                                                                    </div>
                                                                </a>
                                                                <div className="timeDropBox" ref={timeDropBoxRef}>
                                                                    <ul>
                                                                        <li><a href="javascript:void(0)">09:00</a></li>
                                                                        <li><a href="javascript:void(0)">10:00</a></li>
                                                                        <li><a href="javascript:void(0)">11:00</a></li>
                                                                        <li><a href="javascript:void(0)">12:00</a></li>
                                                                        <li><a href="javascript:void(0)">13:00</a></li>
                                                                        <li><a href="javascript:void(0)">14:00</a></li>
                                                                        <li><a href="javascript:void(0)">15:00</a></li>
                                                                        <li><a href="javascript:void(0)">16:00</a></li>
                                                                        <li><a href="javascript:void(0)">17:00</a></li>
                                                                        <li><a href="javascript:void(0)">18:00</a></li>
                                                                        <li><a href="javascript:void(0)">19:00</a></li>
                                                                        <li><a href="javascript:void(0)">20:00</a></li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                            <div className="continueBox">
                                                                <button className="btn continueBtn">Continue <i className="fa-solid fa-chevron-right"></i></button>
                                                            </div>
                                                        </div> */}
                                                    </div>
                                                </div>
                                            </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <NearbyAttractions
                productList={productList}
                isLoading={isDefLoading ? isDefLoading : isLoading}
                attractionNearNextPageUrl={supplierProductNextPageUrl}
                title={'More products from this Operator'}
                onClickLoadMore={onClickLoadMore}
                isAttractionNearLoading={isSupplierProductLoading}

            />

            <NearbyAttractions
                productList={similarTours}
                isLoading={isSimilarTourLoading ? isSimilarTourLoading : isLoading}
                attractionNearNextPageUrl={null}
                title={'You might also like'}
            // onClickLoadMore={onClickLoadMore}
            // isAttractionNearLoading={isAttractionNearLoading}
            />
        </>
    )

}
export default Index;